import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon, getUtility, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import useStyles from './styles';
import { ModalContent } from './content';
import { toJS } from 'mobx';
export default function CADModal(_ref) {
  var _getUtility, _getUtility2;
  let setUtilityCad = _ref.setUtilityCad,
    utility = _ref.utility,
    disabledTrigger = _ref.disabledTrigger,
    onSaveAndClose = _ref.onSaveAndClose,
    isEdit = _ref.isEdit,
    goodWillDeductionValue = _ref.goodWillDeductionValue;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  const saveCadValue = value => {
    setUtilityCad(Number(value));
    onSaveAndClose([{
      values: [{
        key: 'utilityCAD',
        value: Number(value)
      }],
      utility
    }]);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getWarning = isProviderName => /*#__PURE__*/React.createElement("div", {
    className: classes.warning
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "warning",
    title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white"
    }, t('add_new_property_flow.reminder')), isProviderName ? t('add_new_property_flow.enter_provider_name') : t('add_new_property_flow.enter_utility_name')),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    type: "warning",
    fontSize: isProviderName ? 'small' : '',
    state: "warning"
  }))));
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, (_getUtility = getUtility(toJS(utility).name || toJS(utility).utilityTypeName)) === null || _getUtility === void 0 ? void 0 : _getUtility.icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, (_getUtility2 = getUtility(toJS(utility).name || toJS(utility).utilityTypeName)) === null || _getUtility2 === void 0 ? void 0 : _getUtility2.title, ' ', t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ ", t('add_new_property_flow.common_area_deduction')));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, utility.utilityProviderName);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    key: "CAD_Configuration_MODAL",
    id: "CAD_Configuration_MODAL_ID",
    trigger: /*#__PURE__*/React.createElement(Button, {
      key: "CAD_actionButton",
      variant: "actionButton",
      onClick: () => {
        setModalState(true);
      },
      'custom-attribute': '167-cad-modal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('general.edit'))),
    disabledTrigger: disabledTrigger,
    title: modalTitle,
    subTitle: modalSubTitle,
    noFooter: true,
    noPadding: true,
    variant: "staticHeight",
    transparentBackdrop: !isEdit,
    isOpen: modalState,
    handleOpen: () => setModalState(true),
    handleClose: () => {
      setModalState(false);
    }
  }, /*#__PURE__*/React.createElement(ModalContent, {
    utility: utility,
    setUtilityCad: saveCadValue,
    goodWillDeductionValue: goodWillDeductionValue
  }));
}